.c{overflow:hidden;}